<ion-app>
  <ion-router-outlet />
  <a href="https://apps.apple.com/ca/app/id1551385724" id="ios-download-link" #iosDownloadLink>Download</a>
  <a href="https://play.google.com/store/apps/details?id=com.ott.crossborder" id="android-download-link" #androidDownloadLink></a>
</ion-app>
